export { HighlightedContent } from './HighlightedContent';
export type { Props as HighlightedContentProps } from './HighlightedContent';
